export default "__VITE_ASSET__6729f83c__"